export const COULEURS_MARKER = {
  '#4d4d4d': 0,
  '#333333': 1,
  '#000000': 2,
  '#999999': 3,
  '#808080': 4,
  '#666666': 5,
  '#ffffff': 6,
  '#cccccc': 7,
  '#b3b3b3': 8,
  '#f44e3b': 9,
  '#d33115': 10,
  '#9f0500': 11,
  '#fe9200': 12,
  '#e27300': 13,
  '#c45100': 14,
  '#fcdc00': 15,
  '#fcc400': 16,
  '#fb9e00': 17,
  '#dbdf00': 18,
  '#b0bc00': 19,
  '#808900': 20,
  '#a4dd00': 21,
  '#68bc00': 22,
  '#194d33': 23,
  '#68ccca': 24,
  '#16a5a5': 25,
  '#0c797d': 26,
  '#73d8ff': 27,
  '#009ce0': 28,
  '#0062b1': 29,
  '#aea1ff': 30,
  '#7b64ff': 31,
  '#653294': 32,
  '#fda1ff': 33,
  '#fa28ff': 34,
  '#ab149e': 35,
  '#49db70': 36,
  '#f89e37': 37,
  '#e43a45': 38,
  '#3598dc': 39,
  '#c242f4': 40,
};

export const AZIMUT = [
  {
    azimut: 'aucun',
    value: 0,
  },
  {
    azimut: 0,
    min: 0,
    max: 14,
    max2: 359,
    min2: 345,
    value: 1,
  },
  {
    azimut: 30,
    min: 15,
    max: 44,
    value: 12,
  },
  {
    azimut: 60,
    min: 45,
    max: 74,
    value: 11,
  },
  {
    azimut: 90,
    min: 75,
    max: 104,
    value: 10,
  },
  {
    azimut: 120,
    min: 105,
    max: 134,
    value: 9,
  },
  {
    azimut: 150,
    min: 135,
    max: 164,
    value: 8,
  },
  {
    azimut: 180,
    min: 165,
    max: 194,
    value: 7,
  },
  {
    azimut: 210,
    min: 195,
    max: 224,
    value: 6,
  },
  {
    azimut: 240,
    min: 225,
    max: 254,
    value: 5,
  },
  {
    azimut: 270,
    min: 255,
    max: 284,
    value: 4,
  },
  {
    azimut: 300,
    min: 285,
    max: 314,
    value: 3,
  },
  {
    azimut: 330,
    min: 315,
    max: 344,
    value: 2,
  },
];



// WEBPACK FOOTER //
// ./src/components/creationOpportunite/configuration/iconMarkerConf.js